import React from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';
import { useState, useEffect, useMemo } from 'react';
import { BaseUrl, ApiUrl } from '../Component/utitls/config';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link, useNavigate } from 'react-router-dom';
import BgWeb from "../assets/images/banner/inner-prod-bg.jpg";
import BgMob from '../assets/images/banner/mob-inner-prod-bg.jpg';
import enqBtnY from '../assets/images/btn-icons/elements-01.png';
import ProductImg from '../assets/images/icons/prod-shape01.png';
import CategoryBack from '../assets/images/prod-cat-bg.png';
import HeaderMenu from '../Layout/Header';
import Footer from '../Layout/Footer';
import Modal from 'react-bootstrap/Modal';
import formIcon from '../assets/images/btn-icons/elements-02.png'
import StickyProductFinder from '../Layout/StickyProductFinder';
import { Helmet } from 'react-helmet';
import MoonLoader from "react-spinners/MoonLoader";
import ClipLoader from "react-spinners/ClipLoader";
import DownloadIcon from "../assets/images/btn-icons/elements-01.png";
import 'lity/dist/lity.css';
import lity from 'lity';
import { Pagination,Autoplay } from 'swiper/modules';

import { RelProduct, otherCatSlider, ProductTestVid } from '../Component/utitls/SwiperBreakpoint';

const Store = () => {
  const navigate = useNavigate();
  let { ProductType } = useParams();
  const [ProductList, setProductList] = useState([]);
  const [productsToShow, setproductsToShow] = useState(10);
  const [CategoryList, setCategoryList] = useState([]);
  const [CategoryDetails, setCategoryDetails] = useState([]);
  const [showProductEnqForm, setshowProductEnqForm] = useState(false);
  const [EnqProd, setEnqProd] = useState('');
  const [Loading, setLoading] = useState(true);
  const [ProductLoading, setProductLoading] = useState(true);
  // *********************
  const[cropTit, setcropTit] = useState('');
  const [showCropEnqForm, setshowCropEnqForm] = useState(false);
  const [TestiautoplayIndices, setTestiautoplayIndices] = useState([]);
  const [CultiautoplayIndices, setCultiautoplayIndices] = useState([]);

  // ********************
  const [formData, setFormData] = useState({
    firstname: '',
    phoneno: '',
    emailid: '',
  });
  const memoizedProductList = useMemo(() => ProductList, [ProductList]);


  useEffect(() => {
    const fetchProductImages = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${ApiUrl}/produt-type-list/${ProductType}`);
        setProductList(response.data);
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProductImages();
  }, [ProductType]);


  useEffect(() => {
    const fetchCategoryDetails = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/category-det/${ProductType}`);
        setCategoryDetails(response.data);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };
    fetchCategoryDetails();
  }, [ProductType]);

  useEffect(() => {
      if (CategoryDetails && CategoryDetails.AllVideoTestiString) {
          const totalVideos = CategoryDetails.AllVideoTestiString.split(',').length;
          const indices = [];
          for (let i = 1; i < totalVideos; i += 4) {
              indices.push(i);
          }
          setTestiautoplayIndices(indices);
      }
  }, [CategoryDetails]);
  useEffect(() => {
    if (CategoryDetails && CategoryDetails.AllVideoCultiString) {
        const totalVideos = CategoryDetails.AllVideoCultiString.split(',').length;
        const indices = [];
        for (let i = 1; i < totalVideos; i += 4) {
            indices.push(i);
        }
        setCultiautoplayIndices(indices);
    }
}, [CategoryDetails]);


  const loadMoreProducts = () => {
    setproductsToShow(productsToShow + 5);
  };

  useEffect(() => {
    const fetchCategoryList = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/product-Category/${ProductType}`);
        setCategoryList(response.data);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };
    fetchCategoryList();
  }, [ProductType]);


  const handleDelarClose = () => setshowProductEnqForm(false);
  
  const handleDelarShow = (ProdName) => {
    setshowProductEnqForm(true);
    setEnqProd(ProdName);
  }
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formData);
    if (Object.keys(errors).length === 0) {
      formData.ProductName = EnqProd;
      const ApiURL12345 = `${ApiUrl}/send-mail-product`;
      axios.post(ApiURL12345, formData)
        .then(response => {
          // console.log(response.data);
          navigate('/thank-you');
        })
        .catch(error => {
          console.error('Error occurred while sending data:', error);
        });
    } else {
      setErrors(errors);
    }
  };
  const validateForm = (data) => {
    let errors = {};
    if (!data.firstname.trim()) {
      errors.firstname = 'Full name is required';
    }

    if (!data.phoneno.trim()) {
      errors.phoneno = 'Phone number is required';
    } else if (!/^\d{10}$/.test(data.phoneno.trim())) {
      errors.phoneno = 'Invalid phone number';
    }
    if (!data.emailid.trim()) {
      errors.emailid = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(data.emailid.trim())) {
      errors.emailid = 'Invalid email address';
    }
    return errors;
  };
  useEffect(() => {
    setProductLoading(true);
    const timeoutId = setTimeout(() => {
      setProductLoading(false);
    }, 2000);
    return () => clearTimeout(timeoutId);
  }, [ProductType]);
  // *********************************
  const handleCropShow = (CropTitle) => {
    setshowCropEnqForm(true);
    setcropTit(CropTitle);
  }
  const handleCropClose = () => setshowCropEnqForm(false);
  const handleCropSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formData);
    if (Object.keys(errors).length === 0) {
      formData.ProductName = cropTit;
      const ApiURL12345 = `${ApiUrl}/send-crop-mail`;
      axios.post(ApiURL12345, formData)
        .then(response => {
          navigate('/thank-you');
        })
        .catch(error => {
          console.error('Error occurred while sending data:', error);
        });
    } else {
      setErrors(errors);
    }
  };
  // ********************************
  const Loaderstyle = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  const productLoadingStyle = { position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  const CustomRoundedNumber = ({ number }) => {
      const customRound = (num) => {
          let parsedNum = parseFloat(num); // Convert to number safely
          if (isNaN(parsedNum)) return 0; // Handle NaN cases

          let decimalPart = parsedNum - Math.floor(parsedNum);
          return decimalPart <= 0.5 ? Math.floor(parsedNum) : Math.ceil(parsedNum);
      };

      return <span>{customRound(number)}</span>;
  };
  return (
    <>
      {
        Loading ?
          <div style={Loaderstyle}>
            <MoonLoader color={'#0B7B36'} loading={Loading} size={50} />
          </div>
          :
          <>
            <Helmet>
              <title>{CategoryDetails.CategoryDetails?.ProductCategoryMetaTitle}</title>
              <meta name="title" content={CategoryDetails.CategoryDetails?.ProductCategoryMetaTitle} />
              <meta name="description" content={CategoryDetails.CategoryDetails?.ProductCategoryMetaDescription} />
              <link rel="canonical" href={CategoryDetails.CategoryDetails?.ProductCategoryCanonicalTag} />
              <meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' />
            </Helmet>
            <HeaderMenu />

            <main className="main-content">
              <section className="inner-banner-prod-sec position-relative">
                <div className="d-none d-sm-block prodTypeWeb">
                  <img src={BgWeb} loading="lazy" width="1915px" height="172px" />
                </div>
                <div className="d-block d-sm-none prodTypeMob">
                  <img src={BgMob} loading="lazy" width="414px" height="138px" />
                </div>
                <div className="mt-1 prod-detail-breadcum">
                  <div className="container">
                    <div className="row align-item-center">
                      <div className="col-lg-12">
                        <div>
                          <ul className="breadcrumb">
                            <li className="breadcrumb-item">Home</li>
                            <li className="breadcrumb-item"><Link to={`/category/${CategoryDetails.ParentCatDetails?.CategorySlug}`}>{CategoryDetails.ParentCatDetails?.ProductCategoryName}</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">{CategoryDetails.CategoryDetails?.ProductCategoryName}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* ************************* */}
              <section className="p-90 sec-prod-details catagory-prod">
                <div className="container">
                  {ProductList.length > 0 ? (
                    ProductList.map((Product, index) => {
                      return (
                        <div className="row mb-5 mob-height" key={index}>
                          <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                            <div className="prod-detail-img d-none d-sm-block ProdWebFeaImg">
                              {
                                ProductLoading ?
                                  <div style={productLoadingStyle}>
                                    {/* <MoonLoader color={'#0B7B36'} loading={ProductLoading} size={50} /> */}
                                    {/* <BarLoader color="#F2F2F2" speedMultiplier={1} height={464} width={402} loading={ProductLoading}/> */}
                                    <ClipLoader color="#0B7B36" size={50} loading={ProductLoading} />

                                  </div>
                                  :
                                  <Link to={`/product/${CategoryDetails.CategoryDetails?.CategorySlug}/${Product.ProductSlug}`}>
                                    <img src={`${BaseUrl}/Product/${Product.FeatureImage}`} loading="lazy" width="400px" height="439px" />
                                  </Link>
                              }
                              {Product?.DiscountPercentage !== "-" && (
                                  <div className='discount-price'>
                                      <div className='disNum'>{CustomRoundedNumber({ number: Product?.DiscountPercentage })}% off</div>
                                  </div>
                              )}
                            </div>
                            <Link to={`/product/${CategoryDetails.CategoryDetails?.CategorySlug}/${Product.ProductSlug}`} className="d-none d-md-block">
                              <div className="buttonDet">
                                <span>View Details</span>
                              </div>
                            </Link>
                            <div className="prod-detail-img d-block d-sm-none ProdMobFeaImg">
                              {
                                ProductLoading ?
                                  <div style={productLoadingStyle}>
                                    {/* <MoonLoader color={'#0B7B36'} loading={ProductLoading} size={50} /> */}
                                    {/* <BarLoader color="#F2F2F2" speedMultiplier={1} height={370} width={356} loading={ProductLoading}/> */}
                                    <ClipLoader color="#F2F2F2" size={50} loading={ProductLoading} />
                                  </div>
                                  :
                                  <Link to={`/product-specifications/${Product.ProductSlug}`}>
                                    <img src={`${BaseUrl}/Product/${Product.FeatureImage}`} loading="lazy" width="360px" height="439px" />
                                  </Link>
                              }

                            </div>
                          </div>
                          <div className="col-lg-8 col-md-8 col-sm-8 col-12">
                            <div className="prod-hd-sec">
                              <div className="product-deatils-head">
                                <Link to={`/product/${CategoryDetails.CategoryDetails?.CategorySlug}/${Product.ProductSlug}`}>
                                  {/* <h2>Best {Product.ProductName} {CategoryDetails.CategoryDetails?.ProductCategoryName}</h2> */}
                                  <h2>
                                    {Product?.ProductSeoKeyword === "-" ? "Best" : Product?.ProductSeoKeyword}{" "}
                                    {Product?.ProductName}{" "}
                                    {CategoryDetails?.CategoryDetails?.ProductCategoryName}
                                  </h2>
                                </Link>
                              </div>
                              <div className="btn-read-more btn-white d-none d-lg-block">
                                {Product.ProductType === '1' || Product.ProductType === '3' ? (
                                  <Link to={`/product/${CategoryDetails.CategoryDetails?.CategorySlug}/${Product.ProductSlug}`} className="link-primary">
                                    Buy Now <span><img src={enqBtnY} className="btn-green" /></span>
                                  </Link>
                                ) : (
                                    <div className="showprodL">
                                      <a href="Javascript:void(0)" onClick={() => handleDelarShow(Product.ProductName)} className="link-primary">
                                        Enquire Now <span><img src={enqBtnY} className="btn-green" /></span>
                                      </a>
                                    </div>
                                )}

                              </div>
                            </div>

                            <div className="product-deatils">
                              <div className="inner-main-deatils">
                                <div className="main-desp-info">

                                  {Product.ProductPropertiesList && Product.ProductPropertiesList
                                    .sort((a, b) => a.ProductPropertyOrder - b.ProductPropertyOrder)
                                    .slice(0, 2)
                                    .map((property, propIndex) => (
                                      <div className="maturity-swoing" key={propIndex}>
                                        <img src={`${BaseUrl}speicific-icon/${property.ProductPropertyIcon}`} />
                                        <div className="prod-maturity-date">
                                          <h3>{property.ProductProperty}</h3>
                                          <p>{property.ProductPropertyValue}</p>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                                <div className="view-detail-btn d-block d-md-none">
                                  <Link to={`/product-specifications/${Product.ProductSlug}`}>View Specifications</Link>
                                </div>

                                <div className='d-none d-md-block'>
                                  <ul className="prod-details-info ">
                                    <li>
                                      <div className="prod-descrip">
                                        <h3><i className="fa-solid fa-note-sticky"></i> Description</h3>
                                        <div dangerouslySetInnerHTML={{ __html: Product.LongDescription }} />
                                      </div>
                                    </li>
                                    <li>
                                      <div className="prods-other-info prod-descrip">
                                        <h3><i className="fa-solid fa-note-sticky"></i> Specifications</h3>
                                        {Product.ProductPropertiesList && Product.ProductPropertiesList
                                          .sort((a, b) => a.ProductPropertyOrder - b.ProductPropertyOrder)
                                          .slice(2) // Skip the first two items
                                          .map((propertyrest, propIndex) => (
                                            (propertyrest.ProductProperty !== "Duration" && propertyrest.ProductProperty !== "Sowing Time") && propertyrest.ProductPropertyValue !== '-' && (
                                              <p key={propIndex}>
                                                <img src={`${BaseUrl}speicific-icon/${propertyrest.ProductPropertyIcon}`} />
                                                <span><strong>{propertyrest.ProductProperty} :</strong> {propertyrest.ProductPropertyValue}</span>
                                              </p>
                                            )
                                          ))}

                                      </div>
                                    </li>
                                  </ul>

                                </div>
                              </div>
                              <div className="btn-read-more d-block d-lg-none">
                                {Product.ProductType === '1' || Product.ProductType === '3' ? (
                                  <Link to={`/product/${CategoryDetails.CategoryDetails?.CategorySlug}/${Product.ProductSlug}`} className="link-primary">
                                    Buy Now <span><img src={enqBtnY} className="btn-green" /></span>
                                  </Link>
                                ) : (
                                  <a href="#!" onClick={() => handleDelarShow(Product.ProductName)} className="link-primary">
                                    Enquire Now <span><img src={enqBtnY} className="btn-green" /></span>
                                  </a>
                                )}
                                {/* <a href="javascript:void(0)" className="link-primary" data-bs-toggle="modal" data-bs-target="#rightModal">
                                Enquire Now <span><img src={enqBtnY} className="btn-green" /></span>
                              </a> */}
                              </div>
                              <img src={ProductImg} className="prod-shape" />
                            </div>
                          </div>
                        </div>

                      );
                    })
                  ) : (
                    <h1>Coming soon</h1>
                  )}
                </div>
              </section>
              <Modal show={showProductEnqForm} onHide={handleDelarClose} className="formmModal">
                <Modal.Body className="partner-form-brdr">
                  <i className="fa-solid fa-circle-xmark close-partner" onClick={handleDelarClose}></i>

                  <form action="#" method="post" className="" onSubmit={handleSubmit}>
                    <ul>
                      <li>
                        <div className="cont-us-form">
                          <div className="row">
                            <div className="col-lg-12 col-md-6 col-sm-12 col-12">
                              <div className="form-group contact-sec">
                                <i className="fa-solid fa-user"></i>
                                <input type="text" name="firstname" id="firstname" placeholder="Full Name" className="form-control" value={formData.firstname} onChange={handleChange} />
                                {errors.firstname && <div className="errorBox" style={{ color: 'red' }}>{errors.firstname}</div>}
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-12">
                              <div className="form-group contact-sec">
                                <i className="fa-solid fa-phone"></i>
                                <input type="tel" name="phoneno" id="phoneno" placeholder="Phone No." className="form-control" maxlength="10" value={formData.phoneno} onChange={handleChange} />
                                {errors.phoneno && <div className="errorBox" style={{ color: 'red' }}>{errors.phoneno}</div>}
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-12">
                              <div className="form-group contact-sec">
                                <i className="fa-solid fa-envelope"></i>
                                <input type="email" name="emailid" id="emailid" placeholder="Email" className="form-control" value={formData.emailid} onChange={handleChange} />
                                {errors.emailid && <div className="errorBox" style={{ color: 'red' }}>{errors.emailid}</div>}
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                              <div className="btn-read-more">
                                <button type="submit" className="link-primary">Submit Details <span><img src={formIcon} className="btn-green" /></span></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </form>

                </Modal.Body>
              </Modal>
              {/* *************************** */}
              {CategoryDetails.CategoryDetails?.CropGuideBrochure && CategoryDetails.CategoryDetails?.CropGuideBrochure !== "-" && (
                <div className="sec-cropDownload">
                    <a className="sticky-crop" href="#!" onClick={() => handleCropShow(CategoryDetails.CategoryDetails?.CategorySlug)} >
                      {CategoryDetails.CategoryDetails?.CropGuideTitle}
                    </a>
                </div>
              )}
              <Modal show={showCropEnqForm} onHide={handleCropClose} className="formmModal">
                <Modal.Body className="partner-form-brdr">
                  <i className="fa-solid fa-circle-xmark close-partner" onClick={handleCropClose}></i>
                  <form action="#" method="post" className="" onSubmit={handleCropSubmit}>
                    <ul>
                      <li>
                        <div className="cont-us-form">
                          <div className="row">
                            <div className="col-lg-12 col-md-6 col-sm-12 col-12">
                              <div className="form-group contact-sec">
                                <i className="fa-solid fa-user"></i>
                                <input type="text" name="firstname" id="firstname" placeholder="Full Name" className="form-control" value={formData.firstname} onChange={handleChange} />
                                <input type="hidden" name="productN" id="productN" value={cropTit}/>
                                {errors.firstname && <div className="errorBox" style={{ color: 'red' }}>{errors.firstname}</div>}
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-12">
                              <div className="form-group contact-sec">
                                <i className="fa-solid fa-phone"></i>
                                <input type="tel" name="phoneno" id="phoneno" placeholder="Phone No." className="form-control" maxlength="10" value={formData.phoneno} onChange={handleChange} />
                                {errors.phoneno && <div className="errorBox" style={{ color: 'red' }}>{errors.phoneno}</div>}
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-12">
                              <div className="form-group contact-sec">
                                <i className="fa-solid fa-envelope"></i>
                                <input type="email" name="emailid" id="emailid" placeholder="Email" className="form-control" value={formData.emailid} onChange={handleChange} />
                                {errors.emailid && <div className="errorBox" style={{ color: 'red' }}>{errors.emailid}</div>}
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                              <div className="btn-read-more">
                                <button type="submit" className="link-primary">Submit Details <span><img src={formIcon} className="btn-green" /></span></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </form>

                </Modal.Body>
              </Modal>
              {/* ************************************** */}
            {CategoryDetails.AllVideoTestiString?.length > 0 && (
                  <section className="p-90 position-relative sec-relate-category testi-cate-video bg-grey sec-hover" >
                      <div className="container">
                          <div className="inter-text-para">
                               <h2>{CategoryDetails.TestiDeta?.cms_short_title}</h2>
                              <p>{CategoryDetails.TestiDeta?.cms_long_title}</p>
                          </div>
                          <div className="row">
                              <div className="col-lg-12">
                                  <div className="testimony-cont mt-5">
                                      <Swiper className="mySwiper ProductTestVid" loop={true} modules={[Pagination, Autoplay]} pagination={{ clickable: true }} breakpoints={ProductTestVid}
                                      >
                                          {CategoryDetails.AllVideoTestiString.split(',').map((videoId, index) => {
                                              const embedLink = `https://www.youtube.com/watch?v=${videoId}`;
                                              const thumb = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                                              return (
                                                  <SwiperSlide className="swiper-slide" key={index} >
                                                      <div className="testi-vdo">
                                                      {TestiautoplayIndices.includes(index) ? (
                                                          <div className="youtube-embed">
                                                              <iframe
                                                                  width="100%"
                                                                  height="652"
                                                                  src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1`}
                                                                  frameBorder="0"
                                                                  allow="autoplay; encrypted-media"
                                                                  allowFullScreen
                                                                  title={`Video ${index}`}
                                                              ></iframe>
                                                          </div>
                                                      ) : (
                                                          <a href={embedLink} data-lity>
                                                              <img
                                                              src={thumb}
                                                              alt={`YouTube Short ${index + 1}`}
                                                              className="youtube-thumbnail"
                                                              />
                                                              <div className="play-icon-overlay">
                                                                  <div className="play-circle">
                                                                      <div className="play-triangle"></div>
                                                                  </div>
                                                              </div>
                                                          </a>
                                                      )}
                                                          
                                                      </div>
                                                  </SwiperSlide>
                                              );
                                          })}
                                      </Swiper>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
              )}
              {CategoryDetails.AllVideoCultiString?.length > 0 && (
                <section className="p-90 position-relative sec-relate-category testi-cate-video sec-hover">
                    <div className="container">
                        <div className="inter-text-para">
                          <h2>{CategoryDetails.CultiDeta?.cms_short_title}</h2>
                          <p>{CategoryDetails.CultiDeta?.cms_long_title}</p>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="testimony-cont mt-5">
                                    <Swiper
                                        className="mySwiper ProductTestVid"
                                        loop={true}
                                        modules={[Pagination]}
                                        pagination={{ clickable: true }}
                                        breakpoints={ProductTestVid}
                                    >
                                        {CategoryDetails.AllVideoCultiString.split(',').map((videoId, index) => {
                                            const embedLink = `https://www.youtube.com/watch?v=${videoId}`;
                                            const thumb = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                                            return (
                                                <SwiperSlide className="swiper-slide" key={index}>
                                                    <div className="testi-vdo">
                                                        {CultiautoplayIndices.includes(index) ? (
                                                            <div className="youtube-embed">
                                                                <iframe
                                                                    width="100%"
                                                                    height="652"
                                                                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1`}
                                                                    frameBorder="0"
                                                                    allow="autoplay; encrypted-media"
                                                                    allowFullScreen
                                                                    title={`Video ${index}`}
                                                                ></iframe>
                                                            </div>
                                                        ) : (
                                                            <a href={embedLink} data-lity>
                                                                <img
                                                                src={thumb}
                                                                alt={`YouTube Short ${index + 1}`}
                                                                className="youtube-thumbnail"
                                                                />
                                                                <div className="play-icon-overlay">
                                                                    <div className="play-circle">
                                                                        <div className="play-triangle"></div>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        )}
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
              )} 
              {/* *************************** */}
              
              <section className="p-90 sec-relate-category  ${CategoryDetails.AllVideoCultiString?.length > 0 ? 'bg-grey' : ''}`}">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="inter-text-para">
                        <h1>Others Category</h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container mt-5">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="related-list">
                        <Swiper className="swiper mySwiper2 otherCatSlider" loop={true} pagination={{ clickable: true }} breakpoints={{
                          300: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                          },
                          400: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                          },
                          768: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                          },
                          980: {
                            slidesPerView: 4,
                            spaceBetween: 80,
                          },
                          1280: {
                            slidesPerView: 5,
                            spaceBetween: 100,
                          },
                          1600: {
                            slidesPerView: 5,
                            spaceBetween: 100,
                          }
                        }}>
                          <div className="swiper-wrapper">
                            {CategoryList.map(category => (
                              <SwiperSlide className="swiper-slide" >
                                <div className="relcatag-list">
                                  <Link to={`/product-type/${category.CategorySlug}`}>
                                    <div className="related-details">
                                      <div className="prodTypeRel">
                                        <img src={CategoryBack} loading="lazy" width="178px" height="178px" />
                                      </div>
                                      <div className="main-imgp-icon">
                                        <img src={`${BaseUrl}ProductCategory/${category.ProductCategoryIcon}`} />
                                      </div>
                                      <div className="prod-info">
                                        <p>{category.ProductCategoryName} <i className="fa-solid fa-arrow-right-long"></i></p>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              </SwiperSlide>
                            ))}
                          </div>
                          <div className="swiper-pagination"></div>
                        </Swiper>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </main>
            <StickyProductFinder />
            <Footer />
          </>
      }
    </>

  )
}

export default Store